import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useOfferBookingUrl } from 'shared/hooks/useOfferBookingUrl';
import { getOfferCustomUrl } from 'shared/selectors/analytics';
import { selectOfferBookingEnabled } from 'shared/selectors/newbuildingBrokerOfferBooking';
import { trackBookingButtonClick } from 'shared/utils/newbuildingBrokerOfferBooking';

export const NewbuildingBrokerOfferBookingButtonContainer: React.FC = () => {
  const offerBookingEnabled = useSelector(selectOfferBookingEnabled);
  const offerBookingUrl = useOfferBookingUrl('offer_card_main_button');
  const gaLabel = useSelector(getOfferCustomUrl);

  const handleBookingClick = React.useCallback(() => {
    trackBookingButtonClick(gaLabel, 'main_button');
  }, [gaLabel]);

  if (!offerBookingEnabled) {
    return null;
  }

  return (
    <LinkButton fullWidth theme="fill_secondary" href={offerBookingUrl} onClick={handleBookingClick}>
      Заявка на бронирование
    </LinkButton>
  );
};
